import {ActionTypes, LoginActions} from '@app/core/authentication/authentication.actions';
import * as _ from 'lodash-es';

// import {User} from '@app/_models';

export interface State {
    details?: object | null;
    error?: any;
    token: string | null;
}

export const initialState: State = {
    details: null,
    token: null,
    error: null
};

export function reducer(state = initialState, action: LoginActions) {
    switch (action.type) {
        case ActionTypes.LoginSuccess:
            const skipUserProperties = [ 'modules', 'pages', 'permissions' ];
            return {
                ...state,
                details: _.omitBy( action.payload.user, (value, key) => (skipUserProperties.indexOf(key) > -1) ),
                token: action.payload.accessToken
            };

        case ActionTypes.Logout:
            return initialState;

        // case ActionTypes.SessionRestore:
        //     return {
        //         ...state,
        //         details:
        //     }

        case ActionTypes.LoginFailure:
            return {
                ...state,
                error: action.payload.error
            };

        default:
            return state;
    }
}
